
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideas/IdeaViewAllIdeasPage/IdeaViewAllIdeasPage",
      function () {
        return require("private-next-pages/ideas/IdeaViewAllIdeasPage/IdeaViewAllIdeasPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideas/IdeaViewAllIdeasPage/IdeaViewAllIdeasPage"])
      });
    }
  